import Cookies from "js-cookie";

export async function fetchBoxFeed({ params, userTk }) {
  const {
    jours = null,
    section = null,
    isall = 0,
    isporn = 0,
    groupe = null,
    page = 0,
    membre = null, // page profil
    medaille = null, // page profil
    likes = null, // page likes
    numpagevotes = null, // page likes
    favoris = null, // page favoris
    numpagefavoris = null, // page favoris
  } = params;

  // console.log("fetchBoxFeed", params);

  var bodyFormData = new URLSearchParams();

  bodyFormData.append("ads", 1);
  bodyFormData.append("plateforme", "web");

  // pas activé car c'est trop de sacrifices pour au final seulement satisfaire Adsense
  // if (Cookies.get("nsfwinfeed")) {
  //   // on prend le nsfw
  // } else {
  //   bodyFormData.append("nsfw", 0);
  // }

  if (userTk) {
    bodyFormData.append("token", userTk);
  }

  if (page && page > 0) {
    bodyFormData.append("page", page);
  }

  if (isall && isall == 1) {
    bodyFormData.append("all", 1);
  }

  if (isporn && isporn == 1) {
    bodyFormData.append("isporn", 1);
  }

  if (section && section == "new") {
    bodyFormData.append("order", "date");
  } else if (section && section == "top") {
    bodyFormData.append("order", "votes");
  }

  if (jours) {
    bodyFormData.append("jours", jours);
  }

  if (groupe) {
    bodyFormData.append("groupe", groupe);
  }

  if (membre) {
    bodyFormData.append("membre", membre);
  }

  if (medaille) {
    bodyFormData.append("medaille", medaille);
  }

  if (likes) {
    bodyFormData.append("likes", likes);
  }

  if (numpagevotes) {
    bodyFormData.append("numpagevotes", numpagevotes);
  }

  if (favoris) {
    bodyFormData.append("favoris", favoris);
  }

  if (numpagefavoris) {
    bodyFormData.append("numpagefavoris", numpagefavoris);
  }

  // console log the value of bodyFormData in a readable format
  // console.log("bodyFormData:");
  // for (let [key, value] of bodyFormData.entries()) {
  //   console.log(`  ${key}: ${value}`);
  // }

  const timestamp = new Date().getTime();
  const res = await fetch(
    process.env.NEXT_PUBLIC_API_URL + "/api/boxs/boucle?timestamp=" + timestamp,
    {
      cache: "no-store",
      method: "POST",
      body: bodyFormData,
      next: { revalidate: 0 },
    }
  );

  return res.json();
}
